<!--
    <ckeditor #editorElement [disabled]="!!disabled" [editor]="editor" [(ngModel)]="input" (change)="onChange($event)"></ckeditor>
-->

<div class="editorJsInstance" #editorJs></div>